export default __webpack_public_path__ + "static/media/Hammer of the Arena Victor.55317e83.jpg";